// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import "vue-search-select/dist/VueSearchSelect.css";
import VueSpinners from "vue-spinners";

Vue.use(VueSpinners);

// Vue.use(Toast, options);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: false,
});

//@@@@@@@@@@@@@@@@@@@@ Event Bus Section @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
export const EventBus = new Vue();

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import { BootstrapVueIcons } from "bootstrap-vue";
Vue.use(BootstrapVueIcons);

// cssVars()

Vue.use(BootstrapVue);

// mixins
import globalMixin from "../src/mixins/global";
Vue.mixin(globalMixin);

// to use axios globally
import Axios from "axios";
Vue.prototype.$http = Axios;
//here we can submit changes for axios response or error globally
Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status == 406) {
      router.push("/");
    } else {
      return Promise.reject(error);
    }
  }
);

// vue-select
import vSelect from "vue-select";

import vuetify from "./plugins/vuetify";

Vue.component("v-select", vSelect);

/* eslint-disable no-new */
new Vue({
  el: "#app",

  data: {
    // url: 'http://pm.sarmadbs.com/',
    // token: '6aad0847cc2ce0f4c4cb512c98be2a0a12c307ce'
  },

  router,
  template: '<App class="sidebar-hidden"/>',

  components: {
    App,
  },

  vuetify,

  mounted() {
    // if (window.localStorage.api_key === undefined) {
    // window.location = '/#/pages/login'
    // this.router.go('/pages/login')
    // router.push({ name: 'Login' })
    //return
    // }
  },
});
